/* SettingsHeader.tsx generated by @compiled/babel-plugin v2.0.0 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bsb1osq%7Bwidth%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._6rthu2gc%7Bmargin-block-end%3Avar(--ds-space-100%2C8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._bozg1b66%7Bpadding-inline-start%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._y4ti1b66%7Bpadding-inline-end%3Avar(--ds-space-050%2C4px)%7D");
import React, { ReactNode } from 'react';
import IconButton from '@atlaskit/button/icon/button';
import ArrowLeftIcon from '@atlaskit/icon/core/arrow-left';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { Text } from '@atlaskit/primitives/compiled/text';
import { useIntl } from 'react-intl';
import { useAnalytics } from '@townsquare/analytics';
import { teamsAppForYouRoute } from '@townsquare/routes/teams-app-for-you-view';
import { useMetaClickHandler } from '@townsquare/ui-interactions';
const styles = {
  buttonContainer: "_1bsb1osq _6rthu2gc",
  textWrapper: "_bozg1b66 _y4ti1b66"
};
export const SettingsHeader = (): ReactNode => {
  const intl = useIntl();
  const analytics = useAnalytics();
  const {
    handler: backButtonHandler
  } = useMetaClickHandler(teamsAppForYouRoute, undefined, () => {
    analytics.ui('teamsSettingsBackButton', 'clicked');
  });
  return <Inline xcss={styles.buttonContainer} alignBlock="center" grow="fill" space="space.075">
			<IconButton appearance="subtle" icon={ArrowLeftIcon} label={intl.formatMessage({
      id: 'townsquare.teams-settings.header.back-button-label',
      defaultMessage: 'Go back',
      description: 'Label for the teams settings header back button in the side navigation'
    })} onClick={backButtonHandler} isTooltipDisabled={false} />
			<Box xcss={styles.textWrapper}>
				<Text size="medium" color="color.text.subtle" weight="semibold">
					{intl.formatMessage({
          id: 'townsquare.teams-settings.header.title',
          defaultMessage: 'Teams settings',
          description: 'Title for the teams settings header in the side navigation'
        })}
				</Text>
			</Box>
		</Inline>;
};